import { SceneKey } from "./scene-keys";
import { registeredPlayScenes } from "./proto-registry";

export * from "./scene-keys";

type SceneId = (typeof SceneKey)[keyof typeof SceneKey];

function buildAllowedTransitions(): Record<SceneId, readonly SceneId[]> {
  const play = registeredPlayScenes();
  const map: Partial<Record<SceneId, SceneId[]>> = {
    [SceneKey.Boot]: [SceneKey.Title, ...play],
    [SceneKey.Title]: [...play],
  };

  for (const s of play) {
    map[s] = [SceneKey.Title, s];
  }

  // Dropfront play is not a hub entry — Select ↔ Play ↔ Title
  map[SceneKey.DropfrontSelect] = [
    SceneKey.Title,
    SceneKey.Dropfront,
    SceneKey.DropfrontSelect,
  ];
  map[SceneKey.Dropfront] = [
    SceneKey.DropfrontSelect,
    SceneKey.Dropfront,
    SceneKey.Title,
  ];

  // Raid: Title → hub → Sim Lab | roster ↔ battle
  map[SceneKey.RaidHub] = [
    SceneKey.Title,
    SceneKey.RaidSim,
    SceneKey.RaidRoster,
    SceneKey.RaidHub,
  ];
  map[SceneKey.RaidSim] = [
    SceneKey.RaidHub,
    SceneKey.RaidRoster,
    SceneKey.RaidSim,
  ];
  map[SceneKey.RaidRoster] = [
    SceneKey.RaidHub,
    SceneKey.RaidBattle,
    SceneKey.RaidRoster,
  ];
  map[SceneKey.RaidBattle] = [
    SceneKey.RaidRoster,
    SceneKey.RaidBattle,
    SceneKey.Title,
  ];

  return map as Record<SceneId, readonly SceneId[]>;
}

const ALLOWED_TRANSITIONS = buildAllowedTransitions();

export function canTransition(from: SceneId, to: SceneId): boolean {
  return ALLOWED_TRANSITIONS[from]?.includes(to) ?? false;
}

export function assertTransition(from: SceneId, to: SceneId): void {
  if (!canTransition(from, to)) {
    throw new Error(`Invalid scene transition: ${from} -> ${to}`);
  }
}
